import React from 'react';
import {
  VStack, Text, Heading, Icon, HStack, Button, ButtonText, Spinner,
} from '@gluestack-ui/themed';
import { CheckCircle } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

const EventTaskCompletedView = ({
  readOnly,
  isLoading,
  onUnmarkDone,
  isProctoredExam = false,
}) => {
  const { t } = useTranslation();

  return (
    <VStack space="md" pt="$4" borderTopWidth="$px" borderTopColor="$borderLight200" alignItems="center">
      <HStack alignItems="center" space="sm">
        <Icon as={CheckCircle} size="md" color="$green600" />
        <Heading size="sm">
          {isProctoredExam
            ? t('student.eventTask.proctoredSubmittedTitle', 'Quiz already submitted')
            : t('student.eventTask.completedTitle', 'Event Task Completed')}
        </Heading>
      </HStack>
      <Text size="sm" color="$textSubtle" textAlign="center">
        {isProctoredExam
          ? t(
            'student.eventTask.proctoredSubmittedMessage',
            'You already submitted your quiz data for this proctored exam.',
          )
          : t('student.eventTask.completedMessage', 'You have completed this event task.')}
      </Text>
      {!readOnly && !isProctoredExam && onUnmarkDone && (
        <Button
          variant="outline"
          size="sm"
          action="secondary"
          onPress={onUnmarkDone}
          isDisabled={isLoading}
        >
          {isLoading ? (
            <HStack alignItems="center" space="sm">
              <Spinner size="small" />
              <ButtonText>{t('student.eventTask.reenabling', 'Re-enabling...')}</ButtonText>
            </HStack>
          ) : (
            <ButtonText>{t('student.eventTask.registerAnother', 'Register for Another Session')}</ButtonText>
          )}
        </Button>
      )}
    </VStack>
  );
};

export default EventTaskCompletedView;
